<div id="planthunter">
  <planthunter-detail-component
    [hunterId]="hunterId"
    [planthunterOverviewURL]="getHuntersOverviewUrl()"
  ></planthunter-detail-component>
</div>
